import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";

const formatErr = (detail) => {
  if (!detail) return "Error desconocido";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return String(detail);
};

export default function AdminLogin() {
  const { user, login, loading } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("admin@galola.com");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  if (loading) return null;
  if (user) return <Navigate to="/admin" replace />;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await login(email, password);
      toast.success("Bienvenida de nuevo, GALOLÀ");
      navigate("/admin");
    } catch (err) {
      toast.error(formatErr(err.response?.data?.detail) || err.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-4" data-testid="admin-login-page">
      <div className="w-full max-w-md bg-[#FAF9F5] border border-[#E5E0D8] p-10">
        <div className="text-center mb-8">
          <div className="font-serif-editorial text-3xl tracking-[0.25em] mb-2">
            GALOLÀ
          </div>
          <div className="label-tracked text-[#C27A62]">Panel de administración</div>
        </div>
        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label className="label-tracked text-[#1E1E1E] block mb-2">Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="input-clean"
              required
              data-testid="login-email-input"
            />
          </div>
          <div>
            <label className="label-tracked text-[#1E1E1E] block mb-2">Contraseña</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="input-clean"
              required
              data-testid="login-password-input"
            />
          </div>
          <button
            type="submit"
            disabled={submitting}
            className="btn-primary w-full"
            data-testid="login-submit-btn"
          >
            {submitting ? "Entrando..." : "Entrar"}
          </button>
        </form>
      </div>
    </div>
  );
}
